module.exports = __webpack_public_path__ + "static/img/ex_b4.8b44a28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ex_b4.jpg
// module id = BFbl
// module chunks = 1